<script setup>
import { Suspense } from "vue";
import { GlobalLoading } from "ayo-pramuka-component";
</script>

<template>
  <Suspense>
    <template #default>
      <router-view />
    </template>
    <template #fallback>
      <GlobalLoading />
    </template>
  </Suspense>
</template>
